(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Phone number: block non-numeric characters in real-time
    const phoneInput = document.getElementById('ContactForm-phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9+\s\-()]/g, '');
      });
    }

    const fileInput = document.getElementById('ContactForm-file');
    const uploadLabel = document.querySelector('.upload-area');
    const statusDiv = document.getElementById('uploadStatus');
    const hiddenUrlInput = document.getElementById('ContactForm-image-url');

    // Handle File Selection
    fileInput.addEventListener('change', function () {
      const file = this.files[0];
      if (!file) return;

      // Simple validation for size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        statusDiv.innerText = '❌ File is too large (Max 5MB)';
        statusDiv.style.color = '#ef4444';
        return;
      }

      const formData = new FormData();
      formData.append('image', file);

      statusDiv.innerText = 'Uploading...';
      statusDiv.style.color = '#fff';

      // NOTE: Replace 'YOUR_IMGBB_API_KEY' with your actual key if you want the upload to work.
      fetch('https://api.imgbb.com/1/upload?key=8a407085a78ac445d4428b978e89c43c', {
        method: 'POST',
        body: formData,
      })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const url = data.data.url;
          hiddenUrlInput.value = url;
          statusDiv.innerHTML = `✅ Uploaded! <a href="${url}" target="_blank" style="color:#ff6b00">View Image</a>`;
          uploadLabel.style.borderColor = '#22c55e';
        } else {
          statusDiv.innerText = '❌ Upload failed. Please try again.';
          statusDiv.style.color = '#ef4444';
        }
      })
      .catch(() => {
        statusDiv.innerText = '❌ Upload error. Check API Key.';
        statusDiv.style.color = '#ef4444';
      });
    });

    // Drag and Drop Visuals
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      uploadLabel.addEventListener(eventName, preventDefaults, false);
    });

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    ['dragenter', 'dragover'].forEach(eventName => {
      uploadLabel.addEventListener(eventName, () => uploadLabel.style.borderColor = '#ff6b00', false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      uploadLabel.addEventListener(eventName, () => uploadLabel.style.borderColor = '#555', false);
    });

    uploadLabel.addEventListener('drop', handleDrop, false);

    function handleDrop(e) {
      const dt = e.dataTransfer;
      const files = dt.files;
      fileInput.files = files;

      // Trigger change event manually
      const event = new Event('change');
      fileInput.dispatchEvent(event);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
